export default {
  methods: {
    render_prices(data) {
      let option = {
          title: {
              text: '按价格划分',
              top: 10,
              left: 10
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          legend: {
              data: ['销量', '产品数', '产品均销量'],
              top: 20
          },
          grid: {
            left: 50,
            bottom: 30,
            right: 50,
            top: 70
          },
          xAxis: [
              {
                  type: 'category',
                  data: data.map(v=>v.category),
                  axisPointer: {
                      type: 'shadow'
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(135,139,160)',
                    interval: 0
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  }
              }
          ],
          yAxis: [
              {
                  name: '销量',
                  type: 'value',
                  min: 0,
                  max: Math.max(...data.map(v=>v.buyNum)),
                  interval: Math.ceil(Math.max(...data.map(v=>v.buyNum)) / 4),
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false },
                  minInterval: 1
              },
              {
                  name: '产品数',
                  type: 'value',
                  min: 0,
                  max: Math.max(...data.map(v=>v.num)),
                  interval: Math.ceil(Math.max(...data.map(v=>v.num)) / 4),
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false },
                  minInterval: 1
              }
          ],
          series: [
              {
                  name: '销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data: data.map(v=>v.buyNum),
                  itemStyle: {
                    color: 'rgb(11,183,142)'
                  }
              },
              {
                  name: '产品均销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data: data.map(v=>v.avgBuyNum),
                  itemStyle: {
                    color: '#00A6ED'
                  }
              },
              {
                  name: '产品数',
                  type: 'bar',
                  yAxisIndex: 1,
                  data: data.map(v=>v.num),
                  itemStyle: {
                    color: 'rgb(250,137,0)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  label: {
                    show: true,
                    position: 'top'
                  }
              },
          ]
      };
      let $instance = this.$echarts.init(this.$refs['prices'][0]);
      $instance.setOption(option);
      $instance.on('legendselectchanged',function(obj){
        console.log(option);
        if(obj.selected['销量']) {
          option.yAxis[0].max = Math.max(...data.map(v=>v.buyNum))
          option.yAxis[0].interval = Math.ceil(Math.max(...data.map(v=>v.buyNum)) / 4)
        }else {
          option.yAxis[0].max = Math.max(...data.map(v=>v.avgBuyNum))
          option.yAxis[0].interval = Math.ceil(Math.max(...data.map(v=>v.avgBuyNum)) / 4)
        }
        $instance.setOption(option);
      })
      $instance.on('click', params=>{
        this.$refs['classify'].handleOptionChange({
          key: 'price',
          name: params.name
        })
      })
    }
  }
}